import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { IntlProviderContext } from './IntlProviderContext';

export const InjectIntlProviderContext = injectIntl(
  ({ intl, children }: { intl: IntlShape; children: React.ReactNode }) => (
    <IntlProviderContext.Provider value={intl}>
      {children}
    </IntlProviderContext.Provider>
  )
);
